import React from 'react'
import { v4 } from 'uuid'
import chunk from 'lodash/chunk'
import { ArticleHeading, Section } from '../content'
import Row from '@bootstrap-styled/v4/lib/Row'
import Col from '@bootstrap-styled/v4/lib/Col'
import styled from 'styled-components'
import Link from 'next/link'

const ListUl = styled.ul`
  list-style: none;
  padding-left: 0;
  @media (max-width: 920px) {
    margin-bottom: 0;
  }
`

function BlockSuburbs ({ title, value, cols = 3 }) {
  const uuid = v4()
  const items = chunk(value, Math.ceil(value.length / cols))

  const lg = Math.floor(12 / cols)
  const md = (lg > 4) ? lg : 4

  const makeLink = (s) => {
    if (typeof s === 'string') return s
    let showLink
		if (!s.link) showLink = false
		else showLink = !s.hidden ?? !!s.id;

    return showLink ? (
      <Link href={'/physiotherapy/[suburbId]'} as={`/physiotherapy/${s.id}`} passHref>
        <a>{s.name}</a>
      </Link>
    ) : s.name
  }

  return (
    <Section>
      { title && <ArticleHeading>{title}</ArticleHeading> }
      <Row>
        {items.map((col, i) => (
          <Col key={`list-${uuid}-col-${i}`} lg={lg} md={md} xs={12}>
            <ListUl>
              {col.map((s, j) => (
                <li key={`list-${uuid}-${i}-${j}`}>{makeLink(s)}</li>
              ))}
            </ListUl>
          </Col>
        ))}
      </Row>
    </Section>
  )
}

export default BlockSuburbs
